import Create from '../views/addresses/Create.vue'
import Index from '../views/addresses/Index.vue'
import Update from '../views/addresses/Update.vue'

export default [
    {
        path: '/addresses',
        name: 'addresses',
        component: Index,
        meta: { title: 'Adressen' }
    },
    {
        path: '/addresses/index',
        redirect: '/addresses'
    },
    {
        path: '/addresses/create',
        name: 'addresses/create',
        component: Create,
        meta: { title: 'Adresse anlegen' }
    },
    {
        path: '/addresses/:id',
        name: 'addresses/update',
        component: Update,
        meta: { title: 'Adresse bearbeiten' }
    }

]
